export default class ShipmentsTable {
  private $pageWrapper: HTMLElement;

  /**
   * The HTML element of the table.
   */
  private $table: HTMLElement;

  /**
   * The HTML elements of the table rows.
   */
  private $rows: NodeListOf<HTMLElement>;

  /**
   * Initializes the shipments table.
   */
  constructor() {
    this.$table = document.querySelector('.tc-shipments__table');
    this.$rows = this.$table.querySelectorAll('.tc-shipments__table__row');
    this.$pageWrapper = document.querySelector('.tc-page-wrapper__content');

    this.$pageWrapper.classList.add('width-md');

    this.$pageWrapper.style.width = `${this.$table.scrollWidth + 64}px`;
    this.$table.style.height = `${this.$table.scrollHeight}px`;
    this.restoreSelectedCheckboxes();
    [].slice.call(this.$rows).forEach($row => {
      $row.addEventListener('click', (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (target.classList.contains('shipment-table-checkbox') || target.classList.contains('is-checkbox')) {
          return;
        }
      });
    });

    this.attachCheckboxEventListeners()
    this.renderList()
  }

  private attachCheckboxEventListeners() {
    document.querySelectorAll('.shipment-table-checkbox').forEach((checkbox: HTMLInputElement) => {
      checkbox.addEventListener('change', this.saveSelectedCheckboxes.bind(this));
    });
  }

  private saveSelectedCheckboxes() {
    let selected = JSON.parse(localStorage.getItem('selectedCheckboxes')) || [];
    document.querySelectorAll('.shipment-table-checkbox').forEach((checkbox: HTMLInputElement) => {
      const key = checkbox.getAttribute('data-key');
      const index = selected.indexOf(key);
      selected.length > 1 ? this.enableCompareButton() : this.disableCompareButton()

      if (checkbox.checked && index === -1) {
        if (selected.length >= 20) {
          checkbox.checked = false;
          this.showModal();
          return
        }
        selected.push(key);
      } else if (!checkbox.checked && index !== -1) {
        selected.splice(index, 1);
      }
    });
    localStorage.setItem('selectedCheckboxes', JSON.stringify(selected));
    this.renderList();
  }

  private enableCompareButton()
  {
      let compareButton = document.getElementById("compare-shipments-button");
      compareButton.classList.remove('disabled');
      compareButton.classList.remove('btn-secondary')
      compareButton.classList.add('btn-success')
  }

  private disableCompareButton()
  {
    let compareButton = document.getElementById("compare-shipments-button");
    compareButton.classList.remove('btn-success')
    compareButton.classList.add('disabled');
    compareButton.classList.add('btn-secondary')
  }

  private restoreSelectedCheckboxes() {
    let selected = JSON.parse(localStorage.getItem('selectedCheckboxes')) || [];

    if (selected.length > 1) {
        this.enableCompareButton()
    }
    document.querySelectorAll('.shipment-table-checkbox').forEach((checkbox: HTMLInputElement) => {
      if (selected.includes(checkbox.getAttribute('data-key'))) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });
  }

  private renderList() {
    let selected = JSON.parse(localStorage.getItem('selectedCheckboxes')) || [];
    let listContainer = document.getElementById('selected-items-list');

    listContainer.innerHTML = '';

    selected.forEach((item, index) => {  // Use an arrow function here
      let listItem = document.createElement('span');
      listItem.textContent = item;

      // Create the remove button
      let removeBtn = document.createElement('span');
      removeBtn.textContent = 'X';
      removeBtn.className = 'remove-btn';

      // Attach click event to the remove button using an arrow function
      removeBtn.addEventListener('click', () => {
        // Remove the item from the selected array
        selected.splice(index, 1);
        // Update localStorage
        localStorage.setItem('selectedCheckboxes', JSON.stringify(selected));
        // Re-render the list
        this.restoreSelectedCheckboxes();
        this.renderList();
      });

      // Append the remove button to the list item
      listItem.appendChild(removeBtn);
      // Append the list item to the container
      listContainer.appendChild(listItem);
    });
  }

  private showModal() {
    const modal = document.getElementById('max-shipment-selection');
    modal.classList.add('show');
    modal.style.display = 'block';
    modal.setAttribute('aria-modal', 'true');
    modal.removeAttribute('aria-hidden');

    const backdrop = document.createElement('div');
    backdrop.classList.add('modal-backdrop', 'fade', 'show');
    document.body.appendChild(backdrop);

    modal.querySelector('.close').addEventListener('click', () => {
      this.hideModal(modal, backdrop);
    });

    backdrop.addEventListener('click', () => {
      this.hideModal(modal, backdrop);
    });
  }

  private hideModal(modal, backdrop) {
    modal.classList.remove('show');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    modal.removeAttribute('aria-modal');
    document.body.removeChild(backdrop);
  }
}